import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMining = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M14.5309 12.469L6.61888 20.38C6.22105 20.7778 5.68149 21.0013 5.11888 21.0013C4.55627 21.0013 4.0167 20.7778 3.61888 20.38C3.22105 19.9822 2.99756 19.4426 2.99756 18.88C2.99756 18.3174 3.22105 17.7778 3.61888 17.38L11.5309 9.46802",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M15.686 4.31402C14.1763 3.37351 12.4832 2.76604 10.7199 2.5322C8.95661 2.29836 7.16372 2.44353 5.46102 2.95802C5.30944 3.05452 5.18666 3.19008 5.10559 3.35045C5.02452 3.51082 4.98817 3.69007 5.00035 3.86935C5.01252 4.04863 5.07278 4.22132 5.17479 4.36925C5.2768 4.51719 5.41678 4.6349 5.58002 4.71002C7.85742 5.48785 9.99178 6.63407 11.898 8.10302",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_3",
			d: "M17.6999 3.70004C17.513 3.51681 17.2617 3.41418 16.9999 3.41418C16.7382 3.41418 16.4868 3.51681 16.2999 3.70004L11.6999 8.30004C11.5167 8.48697 11.4141 8.73829 11.4141 9.00004C11.4141 9.26179 11.5167 9.51311 11.6999 9.70004L14.2999 12.3C14.4868 12.4833 14.7382 12.5859 14.9999 12.5859C15.2617 12.5859 15.513 12.4833 15.6999 12.3L20.2999 7.70004C20.4831 7.51311 20.5858 7.26179 20.5858 7.00004C20.5858 6.73829 20.4831 6.48697 20.2999 6.30004L17.6999 3.70004Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_4",
			d: "M19.686 8.31396C20.6264 9.82373 21.2338 11.5168 21.4677 13.2801C21.7015 15.0434 21.5564 16.8363 21.0419 18.539C20.9454 18.6903 20.8099 18.8128 20.6496 18.8937C20.4893 18.9746 20.3103 19.0109 20.1312 18.9987C19.9521 18.9866 19.7795 18.9264 19.6317 18.8246C19.4839 18.7227 19.3662 18.583 19.2909 18.42C18.5132 16.1422 17.367 14.0075 15.8979 12.101",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMining;
